import React, { useState } from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  Stack,
  IconButton,
  Paper,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import QR_Image from "../assets/qr_image.jpeg";

const Support = () => {
  const [copied, setCopied] = useState(false);
  const upiId = "robiora@upi";

  const copyUpi = async () => {
    await navigator.clipboard.writeText(upiId);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box
      sx={{
        minHeight: "90vh",
        display: "flex",
        alignItems: "center",
        px: 3,
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
          }}
        >
          {/* LEFT SIDE */}
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                fontSize: { xs: "2.8rem", md: "4rem" },
                fontWeight: 900,
                lineHeight: 1.1,
                background: "linear-gradient(90deg, #1e293b, #2563eb)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Power the Future of <br />
              Research Intelligence
            </Typography>

            <Typography
              sx={{
                mt: 3,
                fontSize: "1.1rem",
                color: "#475569",
                maxWidth: 500,
              }}
            >
              ROBIO is built independently to transform research discovery. Your
              support accelerates innovation and growth.
            </Typography>

            <Button
              variant="contained"
              sx={{
                mt: 4,
                px: 5,
                py: 1.4,
                borderRadius: 50,
                fontWeight: 700,
                background: "linear-gradient(90deg, #1e293b, #2563eb)",
                boxShadow: "0 8px 20px rgba(37,99,235,0.25)",
              }}
            >
              Support ROBIO
            </Button>
          </Box>

          {/* RIGHT SIDE CARD */}
          <Paper
            elevation={6}
            sx={{
              flex: 1,
              maxWidth: 460,
              p: 5,
              borderRadius: 5,
              textAlign: "center",
            }}
          >
            <Stack spacing={4} alignItems="center">
              <Box
                component="img"
                src={QR_Image}
                alt="ROBIO QR"
                sx={{
                  width: 220,
                  height: 220,
                  // borderRadius: 3,
                }}
              />

              <Typography
                sx={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  color: "#1e293b",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {upiId}
                <IconButton onClick={copyUpi}>
                  <ContentCopyIcon />
                </IconButton>
              </Typography>

              <Button
                variant="contained"
                fullWidth
                href={`upi://pay?pa=${encodeURIComponent(
                  upiId,
                )}&pn=ROBIO%20Research&cu=INR`}
                sx={{
                  py: 1.5,
                  borderRadius: 3,
                  fontWeight: 700,
                  background: "linear-gradient(90deg,#22c55e,#16a34a)",
                }}
              >
                Contribute via UPI
              </Button>
            </Stack>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default Support;
